import { Link } from "react-router-dom";

const columns = [
  {
    title: "功能",
    items: [
      { label: "翻页阅读", to: "/features" },
      { label: "下拉阅读", to: "/features" },
      { label: "夜间模式", to: "/features" },
      { label: "离线缓存", to: "/features" },
    ],
  },
  {
    title: "漫画库",
    items: [
      { label: "热血冒险", to: "/comics" },
      { label: "玄幻奇幻", to: "/comics" },
      { label: "治愈日常", to: "/comics" },
      { label: "悬疑推理", to: "/comics" },
    ],
  },
  {
    title: "关于",
    items: [
      { label: "关于我们", to: "/about" },
      { label: "内容原则", to: "/about" },
      { label: "使用帮助", to: "/about" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-800 text-background-50">
      <div className="mx-auto w-full px-4 py-12 md:px-8 md:py-16">
        <div className="grid grid-cols-2 gap-8 md:grid-cols-5">
          <div className="col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-lg text-background-50">
                <i className="ri-book-2-line" />
              </span>
              <span className="font-heading text-xl">扑飞漫画网</span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-background-200">
              多种阅读姿势自由切换。打开就能按习惯看，翻页顺滑，夜间不刺眼，缓存了没网也能看。
            </p>
            <div className="mt-5 flex items-center gap-3">
              {["ri-wechat-line", "ri-weibo-line", "ri-mail-line"].map((ic) => (
                <a
                  key={ic}
                  href="#"
                  rel="nofollow"
                  aria-label="社交链接"
                  className="flex h-10 w-10 items-center justify-center rounded-full bg-background-100/10 text-lg text-background-100 transition-colors hover:bg-primary-500 hover:text-background-50"
                >
                  <i className={ic} />
                </a>
              ))}
            </div>
          </div>

          {columns.map((col) => (
            <div key={col.title}>
              <h4 className="font-heading text-base text-background-50">{col.title}</h4>
              <ul className="mt-4 space-y-3">
                {col.items.map((it) => (
                  <li key={it.label}>
                    <Link
                      to={it.to}
                      className="text-sm text-background-200 transition-colors hover:text-primary-400"
                    >
                      {it.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-100/15 pt-6 text-xs text-background-300 sm:flex-row">
          <p>© {new Date().getFullYear()} 扑飞漫画网 保留所有权利</p>
          <p>让每一页都合你心意 · 多种阅读姿势自由切换</p>
        </div>
      </div>
    </footer>
  );
}